import Vue from "vue";
import { ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import i18n from "@/libs/i18n";
import router from "./router";
import store from "./store";
import App from "./App";

// Global Components
import "./global-components";

// 3rd party plugins
import "@axios";
// import "@/libs/acl";
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
// import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/tour";
import authHelpers from "./utils/auth-helpers";

// Axios Mock Adapter
// import "@/@fake-db/db";
require("dayjs/locale/ar-iq");
import moment from "dayjs";
var relativeTime = require("dayjs/plugin/relativeTime");
moment.extend(relativeTime);
moment.locale("ar-iq");
import { FRONT_BASE_URL, BACK_BASE_URL } from "./base-url.js";

import { createProvider } from "./vue-apollo";

import LottieVuePlayer from "@lottiefiles/vue-lottie-player";

Vue.prototype.$moment = moment;
Vue.prototype.$baseUrl = FRONT_BASE_URL;
Vue.prototype.$backBaseUrl = BACK_BASE_URL;

// BSV Plugin Registration
// Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(LottieVuePlayer);

// Composition API
Vue.use(VueCompositionAPI);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
// require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

import { VueQueryPlugin } from "vue-query";

Vue.use(VueQueryPlugin);

// import core styles
require("@core/scss/core.scss");

// import assets styles
// require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

Vue.directive("can", {
  bind: function (el, binding, vnode) {
    if (binding.value.action) {
      if (!authHelpers.canAction(binding.value.slug, binding.value.action))
        el.style.display = "none";
    } else {
      if (!authHelpers.canNavigate(binding.value.slug))
        el.style.display = "none";
    }
  },
});

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

new Vue({
  router,
  store,
  i18n,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount("#app");
